import * as L from "leaflet";
import { kontram } from "../../../src/theme/muiTheme";

// Export for testing purposes
export const calculateStroke = (
  redPercent,
  orangePercent,
  greenPercent,
  circumference
) => {
  const redStroke = (redPercent * circumference) / 100;
  const orangeStroke = (orangePercent * circumference) / 100;
  const greenStroke = (greenPercent * circumference) / 100;
  const greenOffset = Number(redStroke) + Number(orangeStroke);

  return {
    redStroke,
    orangeStroke,
    greenStroke,
    greenOffset,
  };
};

export const createCustomPieChartMarker = function (
  red,
  orange,
  green,
  total,
  boxSize,
  circleSize
) {
  const innerCircleRadius = circleSize / 4;
  const outerCircumference = (2 * Math.PI * boxSize) / 4;
  const circumference = 2 * Math.PI * innerCircleRadius;
  const redPercent = Number.isNaN(((red * 100) / total))
    ? 0
    : ((red * 100) / total).toFixed(2);
  const orangePercent = Number.isNaN(((orange * 100) / total))
    ? 0
    : ((orange * 100) / total).toFixed(2);
  const greenPercent = 100 - redPercent - orangePercent;

  const { redStroke, orangeStroke, greenStroke, greenOffset } = calculateStroke(
    redPercent,
    orangePercent,
    greenPercent,
    circumference
  );

  const {
    redStroke: redStrokeOuter,
    orangeStroke: orangeStrokeOuter,
    greenStroke: greenStrokeOuter,
    greenOffset: greenOffsetOuter,
  } = calculateStroke(
    redPercent,
    orangePercent,
    greenPercent,
    outerCircumference
  );

  const innerCircles = `
    <circle r="${
      boxSize / 4
    }" cx="50%" cy="50%" fill="transparent" stroke="red" stroke-dasharray="${redStrokeOuter} ${outerCircumference}" stroke-width="${
    boxSize / 2
  }" transform="rotate(-90) translate(-${boxSize})" stroke-opacity="35%" data-testid="innerCircle1" />
    <circle r="${
      boxSize / 4
    }" cx="50%" cy="50%" fill="transparent" stroke="${kontram.warning}" stroke-dasharray="${orangeStrokeOuter} ${outerCircumference}" stroke-width="${
    boxSize / 2
  }" stroke-dashoffset="-${redStrokeOuter}" transform="rotate(-90) translate(-${boxSize})" stroke-opacity="35%" data-testid="innerCircle2" />
    <circle r="${
      boxSize / 4
    }" cx="50%" cy="50%" fill="transparent" stroke="${kontram.primary}" stroke-dasharray="${greenStrokeOuter} ${outerCircumference}" stroke-width="${
    boxSize / 2
  }" stroke-dashoffset="-${greenOffsetOuter}" transform="rotate(-90) translate(-${boxSize})" stroke-opacity="35%" data-testid="innerCircle3" />
    <circle r="${innerCircleRadius}" cx="50%" cy="50%" fill="transparent" stroke="red" stroke-dasharray="${redStroke} ${circumference}" stroke-width="${
    circleSize / 2
  }" transform="rotate(-90) translate(-${boxSize})" data-testid="innerCircle4" />
    <circle r="${innerCircleRadius}" cx="50%" cy="50%" fill="transparent" stroke="${kontram.warning}" stroke-dasharray="${orangeStroke} ${circumference}" stroke-width="${
    circleSize / 2
  }" stroke-dashoffset="-${redStroke}" transform="rotate(-90) translate(-${boxSize})" data-testid="innerCircle5" />
    <circle r="${innerCircleRadius}" cx="50%" cy="50%" fill="transparent" stroke="${kontram.primary}" stroke-dasharray="${greenStroke} ${circumference}" stroke-width="${
    circleSize / 2
  }" stroke-dashoffset="-${greenOffset}" transform="rotate(-90) translate(-${boxSize})" data-testid="innerCircle6" />
  `;

  const svgElem = `<svg height="100%" width="100%" viewBox="0 0 ${boxSize} ${boxSize}" data-testid="svgElement" >
   ${innerCircles}
   <text text-anchor="middle" x="50%" y="63%" stroke="white" class="marker-text" data-testid="middleText" >
   ${total}
   </text>
  </svg>`;
  return L.divIcon({
    html: svgElem,
    className: "marker-cluster-custom",
    iconSize: L.point(boxSize, boxSize, true),
  });
};
